import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RelativeDatePipe } from './relative-date.pipe';

@Component({
    standalone: true,
    imports: [CommonModule, RelativeDatePipe],
    selector: 'abs-relative-date',
    template: ` <span [title]="date">{{ date | relativeDate }}</span> `
})
export class RelativeDateComponent {
    @Input()
    date: Date;
}
